export default {
	"f8cd85d283ae7c315e157c9265ad1a86": "保存中...",
	"12b7edf9dfaddb39c1c28bd3cca3423e": "保存图片至相册"
}
